export default "__VITE_ASSET__B5pbqr12__"